import { useState } from "react";

import { ActionUser } from "@/modules/profile/components/ModalUser";

import { UserManagementModalProps } from "../types/commonTypes";

type UserManagementData =
  | null
  | {
      parent?: string;
      parentId: string;
    }
  | {
      id?: string;
      level: string;
      parentId: string;
    };

interface UserManagementModalState {
  user: {
    action: ActionUser;
    open: boolean;
    data: UserManagementData;
  };
}

export const useUserManagementModal = () => {
  const [showUserManagementModal, setShowUserManagementModal] =
    useState<UserManagementModalState>({
      user: {
        action: "add",
        open: false,
        data: null,
      },
    });

  const handleUserManagementModal = ({
    actionType,
    teamId,
    teamLabel,
    userId,
    userData,
  }: UserManagementModalProps) => {
    switch (actionType) {
      case "add":
        setShowUserManagementModal({
          user: {
            action: "add",
            open: true,
            data: {
              parent: teamLabel,
              parentId: teamId,
            },
          },
        });
        break;
      case "edit":
      case "show":
        setShowUserManagementModal({
          user: {
            action: actionType,
            open: true,
            data: {
              id: userId,
              level: `${userData?.firstname} ${userData?.lastname}`.trim(),
              parentId: teamId,
            },
          },
        });
        break;
    }
  };

  return {
    showUserManagementModal,
    setShowUserManagementModal,
    handleUserManagementModal,
  };
};
